import { nowLocalYmdHis } from './time';

export function validateNewTrashcanLocation(location) {
  if (!location) {
    return { ok: false, message: 'Bitte alle Pflichtfelder ausfüllen.' };
  }

  if (!location.title || !location.latitude || !location.longitude || !location.category) {
    return { ok: false, message: 'Bitte alle Pflichtfelder ausfüllen.' };
  }

  return { ok: true };
}

export function buildTrashcanLocationPayload(location) {
  return {
    title: location.title,
    desc: location.desc,
    latitude: location.latitude,
    longitude: location.longitude,
    categories: [location.category],
  };
}

export function buildPfandSpendeUpdatePayload(currentAcf = {}) {
  return {
    acf: {
      ...currentAcf,
      status: 'abgeholt',
      ablaufdatum: nowLocalYmdHis(),
    },
  };
}

export function buildResetLocationState(previousLocation) {
  return {
    title: '',
    desc: '',
    category: '',
    latitude: previousLocation?.latitude ?? null,
    longitude: previousLocation?.longitude ?? null,
  };
}

export default {
  validateNewTrashcanLocation,
  buildTrashcanLocationPayload,
  buildPfandSpendeUpdatePayload,
  buildResetLocationState,
};
